<template>
  <section>
    <div class="card">
      <div class="card-header">
        <h4>Startpage</h4>
      </div>
      <div class="card-body">
        <div class="form-group row">
          <col-label>Layout</col-label>
          <div class="col-8">
            <div class="custom-control custom-radio">
              <input
                class="form-check-input custom-control-input"
                value="primogenitus"
                type="radio"
                v-model="data.startPageLayout"
                id="primogenitus"
              />
              <label
                class="form-check-label custom-control-label"
                for="primogenitus"
                >primogenitus</label
              >
            </div>
            <div
              v-for="(layout, key) in layoutsStartpage"
              :key="key"
              class="custom-control custom-radio"
            >
              <input
                class="form-check-input custom-control-input"
                :value="layout"
                type="radio"
                v-model="data.startPageLayout"
                :id="layout"
              />
              <label
                class="form-check-label custom-control-label"
                :for="layout"
                >{{ layout }}</label
              >
            </div>
          </div>
        </div>
        <div class="form-group">
          <button @click="persist()" class="btn btn-primary">Speichern</button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <h4>Landingpage</h4>
      </div>
      <div class="card-body">
        <div class="tab-pane fade show" id="landingpage" role="tabpanel">
          <div class="form-group row">
            <col-label>Landingpage aktiv?</col-label>
            <div class="col-8">
              <div class="custom-control custom-checkbox">
                <input
                  class="form-check-input custom-control-input"
                  type="checkbox"
                  v-model="data.landingpageActive"
                  id="landingpageActive"
                />
                <label
                  class="form-check-label custom-control-label"
                  for="landingpageActive"
                ></label>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <col-label>Layout</col-label>
            <div class="col-8">
              <div
                v-for="(layout, key) in layoutsLandingpage"
                :key="key"
                class="custom-control custom-radio"
              >
                <input
                  class="form-check-input custom-control-input"
                  :value="layout"
                  type="radio"
                  v-model="data.landingpageLayout"
                  :id="layout"
                />
                <label
                  class="form-check-label custom-control-label"
                  :for="layout"
                  >{{ layout }}</label
                >
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <button @click="persist()" class="btn btn-primary">Speichern</button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import "bootstrap";
export default {
  created() {
    this.$store.dispatch("setting/all").then(() => {
      const settings = this.$store.getters["setting/all"];
      Object.keys(settings).forEach(key => {
        this.data[key] = settings[key];
      });
    });
    this.$http.get("/api/v1/layouts/startpage").then(({ data }) => {
      this.layoutsStartpage = data;
    });
    this.$http.get("/api/v1/layouts/landingpage").then(({ data }) => {
      this.layoutsLandingpage = data;
    });
  },
  methods: {
    persist() {
      const data = Object.assign({}, this.data);
      this.$store.dispatch("setting/update", data).then(() => {
        this.$notify({
          title: "Einstellungen gespeichert",
          type: "success"
        });
      });
    }
  },
  data() {
    return {
      data: {
        startPageLayout: "primogenitus",
        landingpageLayout: "",
        landingpageActive: 0
      },
      layoutsStartpage: [],
      layoutsLandingpage: []
    };
  }
};
</script>
